module.exports = __webpack_public_path__ + "static/media/4_lavallinen_kuorma_auto_a.945c12bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/4_lavallinen_kuorma_auto_a.svg
// module id = 1164
// module chunks = 0